export const START_PAGE = 1;
export const ELEMENTS_PER_PAGE = 16;
